import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36
    },
    receivingCompanyLabel: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
  });


  const ReceivingCompanyDetails = ({shareCertificateDetails}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.receivingCompanyLabel}>Recipient:</Text>
        <Text>{shareCertificateDetails.receivingCompany}</Text>
        <Text style={styles.receivingCompanyLabel}>OF</Text>
        <Text>{shareCertificateDetails.address}</Text>
        <Text style={styles.receivingCompanyLabel}>Is a registered holder of undermentioned shares in {shareCertificateDetails.issueCompanyName}, subject to the constitution thereof.</Text>
    </View>
  );
  
  export default ReceivingCompanyDetails